export default __webpack_public_path__ + "static/media/helpIcon.31789c22.svg";